import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useTagsSelector = () => useSelector((state: StateExtended) => state.tags.tags);
